import { CardHeader } from "reactstrap";
import { H5 } from "../../../../../../AbstractElements";
import { Filters } from "../../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setSideBarOn } from "../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";

const FilterHeader = () => {
  const dispatch = useAppDispatch();

  return (
    <CardHeader onClick={() => dispatch(setSideBarOn())}>
      <H5 className="mb-0">
        {Filters}
        <span className="pull-right">
          <i className="fa fa-chevron-down toggle-data"></i>
        </span>
      </H5>
    </CardHeader>
  );
};
export default FilterHeader;
